import {
    resetNextTokenPageTwitter,
    setNextTokenPageTwitter,
} from '@lib/config';
import { TwitterDataResponse } from '@lib/domain/twitter';
import {
    FetchPostsPayload,
    ITwitterRepository,
    SearchTwitterUserRequest,
    SearchTwitterUserResponse,
    TwitterResult,
} from '@lib/domain/twitter/interface';

import { HTTPService } from '@lib/infra/HTTPService/HTTPService';

interface Dependencies {
    httpService: HTTPService;
}

export class TwitterRepository implements ITwitterRepository {
    private httpService: HTTPService;

    constructor({ httpService }: Dependencies) {
        this.httpService = httpService;
    }

    async searchUser(
        req: SearchTwitterUserRequest,
    ): Promise<SearchTwitterUserResponse> {
        const url = `twitter/user/${req.username}`;

        const res = await this.httpService.get({ url, isHmac: true });
        const { data } = res;
        return data;
    }

    async getPosts({
        user_id,
        next_token,
        page_size = 100,
        username,
    }: FetchPostsPayload): Promise<TwitterDataResponse> {
        const url = `twitter/posts/${user_id}`;
        let data: Record<string, string | number> = {
            page_size: page_size,
            username,
        };
        if (next_token) {
            data.next_token = next_token;
        }

        const res = await this.httpService.get({ url, data, isHmac: true });
        const { data: result } = res;
        if (result.pagination?.next_token && result.data.length !== 0) {
            setNextTokenPageTwitter(result.pagination.next_token);
        } else {
            resetNextTokenPageTwitter();
        }

        return result;
    }
}
